import { render, staticRenderFns } from "./ContentFeedItem.vue?vue&type=template&id=cd3e7f40&scoped=true&"
import script from "./ContentFeedItem.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedItem.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedItem.vue?vue&type=style&index=0&id=cd3e7f40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3e7f40",
  null
  
)

export default component.exports